import React, { Component } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  FormGroup,
  Progress,
  UncontrolledTooltip,
  Spinner,
} from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import moment from 'moment/min/moment-with-locales';
import * as utils from '../../../Application/Services/utils';
import ScoreExplanation from '../shared/scoreExplanation';
import { withTranslation } from 'react-i18next';

class MostSuitableCandidatesModal extends Component {
  closeModalAndClearData = () => {
    this.props.clearMostSuitableCandidatesData();
  };
  render() {
    const { t } = this.props;
    return (
      <div>
        <Modal size="xl" isOpen={this.props.showModal} onClosed={this.closeModalAndClearData} centered>
          <ModalHeader toggle={this.props.onToggle}>
            <em className="fa-2x icon-people mr-2"> {t('modals.MST_SUITABLE_APPLICANTS')}</em>
          </ModalHeader>
          {this.props.loadingMostSuitableCandidates ? (
            <div>
              <br />
              <br />
              <Spinner />
              <br />
              <br />
            </div>
          ) : (
            // <FadeIn>
            <>
              <ModalBody>
                <div className="col-lg-12">
                  {(this.props.mostSuitableCandidates &&
                    this.props.mostSuitableCandidates.map((element, index) => (
                      <fieldset key={index}>
                        <Card md="12" className="card-default">
                          <CardHeader>
                            <h3>
                              <Col>
                                <Link to={`/applicants/details?id=${element.applicant.id}`}>
                                  <em className="fa-md fa fa-user text-warning"></em> {element.applicant.firstName}{' '}
                                  {element.applicant.lastName}
                                </Link>
                              </Col>
                            </h3>
                          </CardHeader>
                          <CardBody>
                            <Row>
                              <Col lg="5">
                                <div className="lead bb">
                                  <strong> {t('modals.APPLICANT_INFO')}</strong>
                                </div>
                                <form className="form-horizontal">
                                  <FormGroup row>
                                    <Col lg="4">{t('common.PHONE_NUMBER')}</Col>
                                    <Col lg="8">
                                      <strong>{element.applicant.phoneNumber}</strong>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup row>
                                    <Col lg="4">{t('common.E_MAIL')}</Col>
                                    <Col lg="8">
                                      <strong>{element.applicant.email}</strong>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup row>
                                    <Col lg="4">{t('applicants.D_O_B')}</Col>
                                    <Col lg="8">
                                      <strong>
                                        {moment
                                          .utc(element.applicant.dateOfBirth)
                                          //globally https://momentjs.com/docs/#/i18n/changing-locale/
                                          .locale('de')
                                          .local()
                                          .format('l')}
                                      </strong>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup row>
                                    <Col lg="4">{t('common.INTRODUCTION')}</Col>
                                    <Col lg="8">
                                      <strong>{element.applicant.introduction}</strong>
                                    </Col>
                                  </FormGroup>
                                </form>
                              </Col>
                              <Col lg="7">
                                <div className="lead bb">
                                  <FormGroup>
                                    <Row>
                                      <Col lg="6">
                                        <strong>
                                          {t('modals.JOB_SCORE_SUMMARY')} ({element.score.combined} /{' '}
                                          {element.job.maxPossibleScore})
                                        </strong>
                                      </Col>
                                      <Col lg="4">
                                        <Progress
                                          value={utils.calculatePercentage(
                                            element.score.combined,
                                            element.job.maxPossibleScore
                                          )}
                                          color={utils.getColorForPercentage(
                                            utils.calculatePercentage(
                                              element.score.combined,
                                              element.job.maxPossibleScore
                                            )
                                          )}
                                        />
                                      </Col>
                                      <Col lg="2">
                                        <strong>
                                          {utils.calculatePercentage(
                                            element.score.combined,
                                            element.job.maxPossibleScore
                                          )}
                                          %
                                        </strong>
                                      </Col>
                                    </Row>
                                  </FormGroup>
                                </div>
                                <form className="form-horizontal">
                                  <FormGroup row>
                                    <Col lg="4">{t('jobs.JOB_TITLE')}</Col>
                                    <Col lg="8">
                                      <strong>{element.job.title}</strong>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup row>
                                    <Col lg="4">{t('applications.JOB_FIELD')}</Col>
                                    <Col lg="8">
                                      <strong>{element.job.field}</strong>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup row>
                                    <Col lg="4">
                                      {t('jobs.MAX_POSSIBLE_SCORE')}&nbsp;
                                      <em
                                        id={`infoMaxScore-${element.applicant.id}`}
                                        style={{ cursor: 'pointer' }}
                                        className="fa mr-2 fas fa-info-circle"
                                      >
                                        <UncontrolledTooltip
                                          delay={{ show: 300, hide: 0 }}
                                          placement="left"
                                          target={`infoMaxScore-${element.applicant.id}`}
                                        >
                                          {t('modals.CALCULATED_FROM_CO_ADND_WE')}
                                        </UncontrolledTooltip>
                                      </em>
                                    </Col>
                                    <Col lg="8">
                                      <div className="badge badge-info">
                                        <strong>{element.job.maxPossibleScore}</strong>
                                      </div>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup row>
                                    <Col lg="4">
                                      {t('modals.SCORE_ACHIEVED')}&nbsp;
                                      <em
                                        id={`infoAchievedScore-${element.applicant.id}`}
                                        style={{ cursor: 'pointer' }}
                                        className="fa mr-2 fas fa-info-circle"
                                      >
                                        <UncontrolledTooltip
                                          delay={{ show: 300, hide: 0 }}
                                          placement="left"
                                          target={`infoAchievedScore-${element.applicant.id}`}
                                        >
                                          {t('modals.CALCULATED_FROM_APPLICANT_ESTIMATES')}
                                        </UncontrolledTooltip>
                                      </em>
                                    </Col>
                                    <Col lg="8">
                                      <div className="badge badge-success">
                                        <strong>{element.score.combined}</strong>
                                      </div>
                                    </Col>
                                  </FormGroup>
                                </form>
                              </Col>
                            </Row>
                            <ScoreExplanation applicantCompetenceAnalisys={element.score.applicantCompetenceAnalisys} />
                          </CardBody>
                        </Card>
                      </fieldset>
                    ))) || (
                    <fieldset>
                      <div className="form-group row align-items-center">
                        <h3> {t('modals.NO_CANDIDATES_FOR_JOB')}</h3>
                      </div>
                    </fieldset>
                  )}
                  <Button color="primary" onClick={this.props.onToggle}>
                    {t('common.OK')}
                  </Button>
                </div>
              </ModalBody>
              <ModalFooter></ModalFooter>
            </>
            // </FadeIn>
          )}
        </Modal>
      </div>
    );
  }
}

export default withRouter(withTranslation('translations')(MostSuitableCandidatesModal));
